// #1324: Shared helper to resolve image URLs returned by the backend.
//
// The backend returns blob/asset URLs for service and category images as
// relative paths (e.g. "uploads/services/abc.png" or "/uploads/services/abc.png").
// When these are handed to an <img src> as-is, the browser resolves them
// against the web app's origin (e.g. http://localhost:3000/uploads/...)
// instead of the API server's origin, producing a 404 and the broken-image
// placeholder with alt text.
//
// This helper prepends the API server origin (derived from REACT_APP_API_BASE_URL
// by stripping the trailing "/api") to any non-absolute path, and leaves
// absolute URLs (http/https, data:, blob:) untouched.

const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://devanza-dev-backend.azurewebsites.net/api';

// Strip trailing "/api" (and any trailing slash) to get the asset origin.
const ASSET_ORIGIN = API_BASE_URL.replace(/\/api\/?$/i, '').replace(/\/+$/, '');

export const resolveImageUrl = (url?: string | null): string => {
    if (!url) return '';
    const trimmed = url.trim();
    if (!trimmed) return '';
    // Absolute URL or data/blob URL — return as-is.
    if (/^(https?:)?\/\//i.test(trimmed) || /^(data|blob):/i.test(trimmed)) {
        return trimmed;
    }
    // Relative path — prepend asset origin and normalize the join.
    const path = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
    return `${ASSET_ORIGIN}${path}`;
};
